export enum DocumentClassEnum {
  Original      = '00000075-1000-0000-0000-000000000001',
  Thumbnail     = '00000075-1000-0000-0000-000000000002',
  Annotation    = '00000075-1000-0000-0000-000000000003',
  Extract       = '00000075-1000-0000-0000-000000000004',
  HighResolutionImage4k = '00000075-1000-0000-0000-000000000005',
  StdHdImage    = '00000075-1000-0000-0000-000000000006',
  FourKBakedIn  = '00000075-1000-0000-0000-000000000007',
  StdBurnedIn    = '00000075-1000-0000-0000-000000000008',
}
